// extracted by mini-css-extract-plugin
module.exports = {"row":"VehicleReportCanceledTable_row_27zep"};